<template>


    <Transition name="modal-fade">
      <div v-if="isdisplay" class="cf-overlay" @click.self="close">
        <Transition name="modal-slide">
          <div v-if="isdisplay" class="cf-dialog cf-dialog--xl">

                <!-- Header -->
                <div class="cf-modal-head cf-dialog-head">
                    <div class="cf-modal-head__main">
                        <span class="cf-modal-head__icon"><i class="ri-file-list-3-line"></i></span>
                        <div>
                            <h4 class="cf-dialog-title">Entête commande</h4>
                        </div>
                    </div>
                    <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                </div>

                <!-- Body -->
                <div class="cf-dialog-body">

                    <div class="alert alert-info text-center mt-3">
                        <p style="color: black;font-size: 15px;">Date : {{Items.datedoc}}  <template v-if="Items.docnum!==''"> / {{Items.docnum}}</template> </p>
                    </div>

                    <div class="box-body">

                        <div class="grid lg:grid-cols-2 mt-5 mb-5 gap-6">

                            <div class="space-y-2">
                                <div class="grid grid-cols-12  gap-x-6 mt-3">

                                    <div class="xl:col-span-10  col-span-10" >
                                        <label class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0">Client</label>


                                        <input :placeholder="'Veuillez sélectionner un client'"  v-if="Items.jsonotherdonne.cltfrs===null" type="text" class="form-control" disabled>
                                        <input v-else :value="Items.jsonotherdonne.cltfrs.name" type="text" class="form-control" disabled>
                                    </div>
                                    <div class="xl:col-span-2  col-span-2">
                                        <label class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0">&nbsp;</label>

                                        <button v-if="!disableddoc"   @click="btnmodallistedescltfrs()"   class="ti-btn ti-btn-success-full ti-btn-lg ti-btn-wave">...</button>
                                        <button v-else   class="ti-btn ti-btn-success-full ti-btn-lg ti-btn-wave">...</button>


                                    </div>
                                </div>
                            </div>

                            <div class="space-y-2">

                                <div class="grid grid-cols-2  gap-x-6 mt-3">

                                    <div class="space-y-2 w-full">
                                        <label class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0">Ifu client</label>
                                        <input v-model="Items.jsonv.ifu" type="text" class="firstName my-auto ti-form-input
                                             rounded-sm" placeholder="Ifu du client sur la facture"   required>


                                    </div>


                                    <div class="space-y-2 w-full">
                                        <label class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0">Nom client</label>
                                        <input v-model="Items.jsonv.client" type="text" class="firstName my-auto ti-form-input
                                             rounded-sm" placeholder="Nom du client sur la facture"   required>

                                    </div>



                                </div>

                            </div>




                            <div class="space-y-2">
                                <label class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0">Serveur</label>

                                <select :disabled="disableddoc" v-model="Items.jsonv.collaborateur" class="my-auto ti-form-input  rounded-sm ti-form-select rounded-sm !py-2 !px-3">
                                    <option  :value="null">Séléctionner un Serveur</option>
                                    <option v-for="(datavalue,index) of alldata.collaborateur" :key="index"
                                            :value="datavalue">{{ datavalue.typecollaborateur+' / '+ datavalue.name}}</option>

                                </select>
                            </div>


                            <div class="space-y-2">
                                <label class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0">Mode de réglement</label>

                                <select :disabled="disableddoc" v-model="Items.jsonv.modereglement" class="my-auto ti-form-input  rounded-sm ti-form-select rounded-sm !py-2 !px-3">
                                    <option  :value="null">Séléctionner un mode de réglement</option>
                                    <option v-for="(datavalue,index) of alldata.modedereglement" :key="index"
                                            :value="datavalue">{{datavalue.name}}</option>

                                </select>
                            </div>


                            <div class="space-y-2">
                                <label class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0">Table</label>

                                <select :disabled="disableddoc" v-model="Items.jsonv.commandetable"
                                        class="my-auto ti-form-input  rounded-sm ti-form-select rounded-sm !py-2 !px-3">
                                    <option  :value="null">Séléctionner une table</option>
                                    <option v-for="(datavalue,index) of alldata.commandetable" :key="index"  :value="datavalue">{{datavalue.name}}</option>

                                </select>
                            </div>

                            <div class="space-y-2">
                                <label class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0">Paramétre d'indication</label>

                                <select :disabled="disableddoc" v-model="Items.jsonv.param"
                                        class="my-auto ti-form-input  rounded-sm ti-form-select rounded-sm !py-2 !px-3">
                                    <option  :value="null">Paramétre d'indication</option>
                                    <option v-for="(datavalue,index) of alldata.paramcaisse" :key="index"  :value="datavalue">{{datavalue.name}}</option>

                                </select>
                            </div>



                        </div>






                    </div>
                </div>

                <!-- Footer -->
                <div class="cf-dialog-foot">
                    <button @click="close" type="button" class="ti-btn ti-btn-secondary-full">Fermer</button>
                    <button @click="selected" type="button" class="ti-btn ti-btn-primary-full">Valider</button>
                </div>

          </div>
        </Transition>
      </div>
    </Transition>

    <modallistfrsclt @elementSelectionnecltfrs="handleElementSelectedcltfrs" ref="modallistfrsclt"></modallistfrsclt>


</template>

<script>

    //import allfunction from "@/allfunction";
    import {isset, randomString} from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";
    import modallistfrsclt from "@/components/views/pages/gestioncommerciale/achatvente/modal_listfrsclt";
    const axios =require('axios');

    export default {
        /* eslint-disable */
        name: "formsupp",
        watch: {


        },

        computed:{
            disableddoc(){

                return this.Items.docnum ?true:false;
            },




        },
        components: {
            modallistfrsclt,

        },

        data() {
            return {
                isdisplay:false,
                datavalue:"",
                titlemodal:"",
                Items:{},
                alldata:{},
                typedoc:"",
                messageerror:"",
                messagesucces:"",
                dataprice:[]
            };
        },
        methods: {

            selected(){

                this.Items.jsonotherdonne.moderglt=this.Items.jsonv.modereglement
                this.Items.jsonotherdonne.collaborateur=this.Items.jsonv.collaborateur
                this.Items.jsonotherdonne.commandetable=this.Items.jsonv.commandetable


                // Suppose que vous avez un objet représentant l'élément sélectionné
                const elementSelectionne = { item: this.Items};

                // Émettre un événement personnalisé avec l'élément sélectionné
                this.$emit('updateentetecommande', elementSelectionne);


                // Fermer le modal ou effectuer d'autres actions nécessaires
                this.isdisplay=false;
            },

            handleElementSelectedcltfrs(elementSelectionne) {

                this.Items.jsonotherdonne.cltfrs=elementSelectionne.value

                if(this.Items.jsonotherdonne.cltfrs!==null){


                    this.Items.jsonv.client=this.Items.jsonotherdonne.cltfrs.name
                    this.Items.jsonv.ifu=this.Items.jsonotherdonne.cltfrs.ifu

                }else{
                    this.Items.jsonv.client='';
                    this.Items.jsonv.ifu='';

                }




            },

            btnmodallistedescltfrs(){


                let listedatable=[],
                    titlemodal="",
                    option=this.typedoc,
                    typedoc="";

                titlemodal="Liste des clients"
                listedatable=this.alldata.beneficiairecl
                option='vvente'


                //this.$refs.modallistfrsclt.show(titlemodal,listedatable,this.typededocument,this.datainputlibelleforms);

                let $CUSTOMLIBELLEFRSCLT=JwtService.getCUSTOMLIBELLEFRSCLT()


                if (isset($CUSTOMLIBELLEFRSCLT)){
                    $CUSTOMLIBELLEFRSCLT=JSON.parse($CUSTOMLIBELLEFRSCLT);

                }
                else{

                    $CUSTOMLIBELLEFRSCLT=this.$store.state.appcustomlibellefrsclt;

                    JwtService.setCUSTOMLIBELLEFRSCLT(JSON.stringify($CUSTOMLIBELLEFRSCLT))


                }


                this.$refs.modallistfrsclt.show(titlemodal,listedatable,option,this.datainputlibelleforms,$CUSTOMLIBELLEFRSCLT);

            },


            close(){

                this.isdisplay=false;


            },


            show(Items,alldata){



                this.Items=Items
                this.alldata=alldata


                this.isdisplay=true;

            },


            async  btnsuppression(){

                this.$store.dispatch('lancerchargement',true)

                //this.Items.cf=this.$store.state.caisseinfo;

                if (this.typedoc==='DEP'){this.typedoc="DP"}


                let value={
                    'cf':this.$store.state.caisseinfo,
                    'item':this.Items,
                    'document':'A'+this.typedoc,
                }


                const t = this;
                let url=process.env.VUE_APP_API_URL+'/egl74587kjkjrfdkcaisse771714dfe/doc/caisse/addfkdfkdozojdj_refdepdpcc/'+this.$store.state.appsociete+'/add895418init51_refdepdpcc11515/'+randomString();
                let response =   axios  .post(url,value,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                let res= await response
                    .then(function (res){
                        // t.$store.dispatch('beartoken',res.data.beartoken)
                        t.$store.dispatch('lancerchargement',false)
                        if(res.data.success){

                            t.messagesucces="";
                            t.messageerror="";

                            t.messagesucces=res.data.message;

                            toastr['success']( t.messagesucces,"<b></b>");


                            t.$emit('closed',res.data.m);

                            t.isdisplay=false;


                        }
                        else{

                            let errormessage="";

                            t.messageerror="";
                            t.messagesucces="";
                            if (res.data.datamessage.length>0){

                                for (let message of res.data.datamessage){

                                    if (errormessage===""){

                                        errormessage=message;

                                    }else{

                                        errormessage+=" , "+message;

                                    }


                                }


                                t.messageerror=errormessage;

                            }
                            else{
                                t.messageerror=res.data.message
                            }


                            toastr['error'](t.messageerror,"<b></b>");

                            t.isdisplay=false;

                        }


                    })
                    .catch(

                        error => toastr['error']( "Une erreur est subvenue. <br/> veuillez contacter votre administrateur.",
                            "<b></b>")
                    )
                    .finally(() => this.$store.dispatch('lancerchargement',false))




            },







        },
        mounted() {

            // this.loaddata();
        }




    }
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:92vh; overflow:hidden; }
.cf-dialog--xl { max-width:900px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; flex:1; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }

.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }

    @media screen and (max-width: 768px) {

        .cf-dialog--xl { max-width:100%; }


    }

</style>